import React from 'react';
import ReactDOM from 'react-dom';
import APP from './App';
import 'bootstrap/dist/css/bootstrap.min.css';

ReactDOM.render(
    <React.StrictMode>
        <APP />
    </React.StrictMode>,
    document.getElementById('root')
);